module.exports = __webpack_public_path__ + "img/katVonD1.08c4e4cc.jpg";